import { fun_PostAction } from "@/api";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      searchFlag:null, // 查询标记
      // 查询表单绑定值
      form: {
        prjName: null, // 工程名称
        prjLargeClass: null, // 工程类别

      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "工程类别：",
          value: "prjLargeClass",
          placeholder: "请输入",
          clearable: true,
          queryParams: {
            url: "/dataDictionaryEntries/engineeringCombobox",
            parentId: "0"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标项目名称",
          prop: "prjName",
          isShow: true,
          fixed: true,
          width: "280",
        },
        {
          label: "招标人",
          prop: "buildCorpName",
          width: "220",
        },
        {
          label: "工程类别",
          prop: "prjLargeClassName",
          width: "150",
        },
        {
          label: "立项文号",
          prop: "noteNumber",
          width: "150",
        },
        {
          label: "项目性质",
          prop: "constructionTypeName",
          width: "150",
        },
        {
          label: "重点工程",
          prop: "isKeyProjectName",
          width: "150",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          width: "250",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
    }
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/construction/constructionChooseList", {
        searchFlag:this.searchFlag, // 工程类二次报建
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      })
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
    * 改变每页条数执行的函数
    * @params e 每页条数
    * @author 滕威
    */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 企业选择
     */
    fun_CorpSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 如果是报建或者非报建
        if (this.searchFlag == '1' || this.searchFlag == '0') {
          // 赋值父页面原建设方（甲方）报建主键
          this.$parent.form.firstConstructionId = e.val.id;
          // 赋值父页面原建设方（甲方）报建编号
          this.$parent.form.firstConstructionNo = e.val.constructionNo;
          // 赋值父页面工程名称
          this.$parent.form.firstConstructionPrjName = e.val.prjName;
          // 旧数据为空时，页面显示为核验
          if(e.val.isAudit == '' || e.val.isAudit == null){
            // 赋值父页面工程名称
            this.$parent.form.isAudit = "1";
          }else{
            // 赋值父页面工程名称
            this.$parent.form.isAudit = e.val.isAudit;
          }
          // 是否报建项目
          this.$parent.form.constructionFlag = e.val.constructionFlag
          // 新增初始化
          this.$parent.fun_InsertInit()
        } 
        // 如果是招标登记
        else if (this.searchFlag == '2'){
          // 调用返回赋值方法
          this.$parent.fun_ConstructionSelected(e);
        }
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    },
  }
}